import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TrailerInterventionsGridComponent} from './trailer-interventions-grid.component';
import {TabModule} from '../tab/tab.module';
import {DxDataGridModule, DxDateBoxModule, DxSelectBoxModule, DxToolbarModule} from 'devextreme-angular';
import {InterventionsToolbarComponent} from './interventions-toolbar/interventions-toolbar.component';
import {InterventionReportModule} from './intervention-report/intervention-report.module';
import {GridTitleModule, BadgeModule} from 'shared';


@NgModule({
  declarations: [TrailerInterventionsGridComponent, InterventionsToolbarComponent],
  imports: [
    CommonModule,
    TabModule,
    DxDataGridModule,
    DxDateBoxModule,
    DxSelectBoxModule,
    DxToolbarModule,
    InterventionReportModule,
    GridTitleModule,
    BadgeModule,
  ],
  exports: [TrailerInterventionsGridComponent]
})
export class TrailerInterventionsGridModule {
}
